import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import E50Footer from "@e50/components/E50FooterComponents/E50Footer";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_E50_LABEL,
  EVENTS_AWARDS_E50_PATH,
} from "@events-awards/utils/constants";
import {
  E50StaticPageFactory,
  getStaticPageTitle,
} from "@events-awards/utils/helpers";
import { AwardType } from "@events-awards/utils/types";
import { useDetectAdBlock } from "adblock-detect-react";

type E50StaticPageProps = {
  /** The url string to get url at E50 static page. */
  urlPath: string;
};

/**
 * Component to render E50 static navigation pages
 */
const E50StaticPage = ({ urlPath }: E50StaticPageProps): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  const StaticLayout = E50StaticPageFactory(urlPath);

  return (
    <div className="w-full" data-testid="e50-static-page-component">
      <AdSettings
        adNames={["lb1", "prestitial", "catfish"]}
        path={EVENTS_AWARDS_E50_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Enterprise 50 Awards"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={getStaticPageTitle(urlPath) + "  - THE BUSINESS TIMES"}
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_E50_LABEL} - Find ${EVENTS_AWARDS_E50_LABEL} News & Headlines, insight and analysis in Singapore, ASCA-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_E50_PATH}
      />

      <EventsAwardsHeader />

      <Container rootClassName="pb-8 w-full justify-center px-3 text-left text-gray-850">
        <EventsAwardsNavigationBar awardType={AwardType.E50} />

        <>{StaticLayout ? <StaticLayout /> : null}</>
      </Container>

      <E50Footer />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default E50StaticPage;
